// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"8":"europe-map","33":"language-selector-block","98":"validity-check","115":"select-app-currency","252":"css/app","346":"map-popup","541":"vuetify-lib","608":"buy-vignette","645":"pricing-section","684":"pricing-section-hero2","725":"mobile-header","975":"why-choose-us-language"}[chunkId] + ".css";
};